import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PAGE_PATHS } from '../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/policies/')({
  validateSearch: zodValidator(withDefaults(schema.POLICIES, defaultFilter)),
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.POLICIES });
    context.validatePermissions({ isAllowed, preload });
  },
});
